import { render, staticRenderFns } from "./Tabulation.vue?vue&type=template&id=29336aa0&scoped=true&"
import script from "./Tabulation.vue?vue&type=script&lang=js&"
export * from "./Tabulation.vue?vue&type=script&lang=js&"
import style0 from "./Tabulation.vue?vue&type=style&index=0&id=29336aa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29336aa0",
  null
  
)

export default component.exports